module.exports = __webpack_public_path__ + "static/buttons-e98267eb13be813c2b6b53efd62213a9.png";